import type {Result, UseCase} from 'framework';
import type {CatalogMuscle} from '../../domain/catalog-muscle';
import type {WorkoutError} from '../../domain/errors';
import type {ExerciseCatalogRepository} from '../ports/exercise-catalog.repository';

export class ListCatalogMuscles implements UseCase<[], readonly CatalogMuscle[]> {
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(): Promise<Result<readonly CatalogMuscle[], WorkoutError>> {
    return this.repository.listMuscles();
  }
}
